import { ChevronLeft, ChevronRight, Maximize2, Minimize2 } from "lucide-react";
import { slides } from "./registry";
import { useDeck } from "./useDeck";
import { useFullscreen } from "./useFullscreen";
import { Overview } from "./Overview";
import { ProgressBar } from "./ProgressBar";
import { SlideViewport } from "./SlideViewport";

export function Deck() {
  const { isFullscreen, toggle } = useFullscreen();
  const { index, direction, overview, dispatch } = useDeck(toggle);
  const slide = slides[index];

  if (!slide) {
    return (
      <div className="flex h-full items-center justify-center text-2xl text-white/60">
        No slides registered yet.
      </div>
    );
  }

  return (
    <div className="absolute inset-0">
      <SlideViewport slide={slide} direction={direction} overview={overview} />

      {/* Invisible edge hot-zones for click-to-advance — never a global click handler */}
      {index > 0 && (
        <button
          type="button"
          aria-label="Previous slide"
          onClick={() => dispatch({ type: "PREV" })}
          className="group absolute inset-y-0 left-0 z-20 flex w-16 items-center justify-start pl-2 outline-none"
        >
          <ChevronLeft className="h-10 w-10 text-white/0 transition duration-300 group-hover:text-white/40" />
        </button>
      )}
      {index < slides.length - 1 && (
        <button
          type="button"
          aria-label="Next slide"
          onClick={() => dispatch({ type: "NEXT" })}
          className="group absolute inset-y-0 right-0 z-20 flex w-16 items-center justify-end pr-2 outline-none"
        >
          <ChevronRight className="h-10 w-10 text-white/0 transition duration-300 group-hover:text-white/40" />
        </button>
      )}

      <ProgressBar
        index={index}
        onGoto={(i) => dispatch({ type: "GOTO", index: i })}
      />

      <button
        type="button"
        aria-label={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
        onClick={toggle}
        className="absolute right-5 top-5 z-30 text-white/25 transition hover:text-white/70"
      >
        {isFullscreen ? <Minimize2 className="h-5 w-5" /> : <Maximize2 className="h-5 w-5" />}
      </button>

      <Overview
        open={overview}
        currentIndex={index}
        onSelect={(i) => dispatch({ type: "GOTO", index: i })}
      />
    </div>
  );
}
